import React, { Fragment, useState, useEffect, useMemo } from "react";
import Input from "../../elements/CustomInput";
import Select from "../../elements/CustomSelect";
import { Table } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";

const CncOrdersList = ({
  cncOrderListing,
  totalCount,
  setPaginate,
  paginate,
  listParamState,
  handleFilterChange,
  storeList,
  onQuoteClick,
}) => {
  const [items, setItems] = useState([]);
  const [isMore, setIsMore] = useState(false);

  const fetchMoreData = () => {
    setTimeout(() => {
      setPaginate(paginate + 10);
    }, 1500);
  };

  useEffect(() => {
    setItems(cncOrderListing);
    if (_.isEqual(totalCount, cncOrderListing.length)) {
      setIsMore(false);
    } else {
      setIsMore(true);
    }
  }, [cncOrderListing]);

  const data = useMemo(() => items, [items]);

  const storeData = useMemo(() => {
    return [].concat(storeList);
  }, [storeList]);

  // Scope types a CnC order can cover (same structure names used across the app).
  const scopeTypeOptions = useMemo(
    () => [
      { label: "Countertops", value: "Countertops" },
      { label: "Cabinet Boxes", value: "Cabinet Boxes" },
      { label: "Doors and Drawers", value: "Doors and Drawers" },
    ],
    []
  );

  // A row can cover several scopes — show the distinct scope types, comma-separated.
  const scopeTypeOf = (row) => {
    const orderItems = Array.isArray(row?.orderItems) ? row.orderItems : [];
    const names = orderItems
      .map((it) => it?.productStructureName ?? it?.ProductStructureName)
      .filter(Boolean);
    return [...new Set(names)].join(", ");
  };

  // Measure date is entered at the order level (see CncOrderDetail: InstallationData.MeasureDate);
  // read it defensively and show blank when it has not been confirmed yet.
  const measureDateOf = (row) =>
    row?.InstallationData?.MeasureDate ??
    row?.orderItems?.[0]?.InstallationData?.MeasureDate ??
    row?.MeasureDate ??
    "";

  return (
    <Fragment>
      <Table bordered responsive>
        <InfiniteScroll
          dataLength={data.length}
          next={fetchMoreData}
          hasMore={isMore}
          loader={
            <div className="data-loading">
              <img src="https://64.media.tumblr.com/695ce9a82c8974ccbbfc7cad40020c62/tumblr_o9c9rnRZNY1qbmm1co1_1280.gifv" />
              <span>Load More</span>
            </div>
          }
        >
          <thead>
            <tr>
              <th style={{ verticalAlign: "top" }}>
                <Input label="Job No." ids="quoteNumber" value={listParamState.jobNo} handleChange={handleFilterChange} validate={false} />
              </th>
              <th style={{ verticalAlign: "top" }}>
                <Input label="Property Name" ids="shipToPropertyName" value={listParamState.shipToPropertyName} handleChange={handleFilterChange} validate={false} />
              </th>
              <th style={{ verticalAlign: "top" }}>
                <Input label="Unit Type" ids="unitTypeName" value={listParamState.unitTypeName} handleChange={handleFilterChange} validate={false} />
              </th>
              <th style={{ verticalAlign: "top" }}>
                <Input label="Unit No." ids="unitName" value={listParamState.unitName} handleChange={handleFilterChange} validate={false} />
              </th>
              <th style={{ verticalAlign: "top" }}>
                <Select label="Scope Type" ids="ScopeType" result={scopeTypeOptions} value={listParamState.ScopeType} handleChange={handleFilterChange} validate={false} />
              </th>
              <th style={{ verticalAlign: "top" }}>
                <Input label="Installation Date" ids="InstallationDate" value={listParamState.InstallationDate} handleChange={handleFilterChange} validate={false} />
              </th>
              <th style={{ verticalAlign: "top" }}>
                <Input label="Measure Date" ids="MeasureDate" value={listParamState.MeasureDate} handleChange={handleFilterChange} validate={false} />
              </th>
              <th style={{ verticalAlign: "top" }}>
                <Select label="Store Name" ids="StoreId" result={storeData} value={listParamState.StoreId} handleChange={handleFilterChange} validate={false} />
              </th>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(data) ? (
              _.map(data, (row, index) => {
                const InstallationDate = row.orderItems?.[0]?.InstallationDate;
                return (
                  <tr key={index} style={{ verticalAlign: "top" }}>
                    <td style={{ verticalAlign: "top" }}>
                      <div className="link" onClick={() => onQuoteClick(row)}>
                        {_.get(row, "jobNo", "")}
                      </div>
                    </td>
                    <td style={{ verticalAlign: "top" }}>{_.get(row, "shipToPropertyName", "")}</td>
                    <td style={{ verticalAlign: "top" }}>{_.get(row, "unitTypeName", "")}</td>
                    <td style={{ verticalAlign: "top" }}>{_.get(row, "UnitName", "")}</td>
                    <td style={{ verticalAlign: "top" }}>{scopeTypeOf(row)}</td>
                    <td style={{ verticalAlign: "top" }}>{InstallationDate}</td>
                    <td style={{ verticalAlign: "top" }}>{measureDateOf(row)}</td>
                    <td style={{ verticalAlign: "top" }}>{_.get(row, "store", "")}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={8}>No Data Found</td>
              </tr>
            )}
          </tbody>
        </InfiniteScroll>
      </Table>
    </Fragment>
  );
};

export default CncOrdersList;
